import { render, staticRenderFns } from "./MainLayoutUser.vue?vue&type=template&id=6f268a42&scoped=true&"
import script from "./MainLayoutUser.vue?vue&type=script&lang=ts&"
export * from "./MainLayoutUser.vue?vue&type=script&lang=ts&"
import style0 from "./MainLayoutUser.vue?vue&type=style&index=0&id=6f268a42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f268a42",
  null
  
)

export default component.exports